import { type DataObjectsManager, type IDataObject } from '@inpart-io/devtools-iap';
import { type AssetCategory } from '@inpart-io/padme-iap';

import { assetCategoryMap } from '@/constants/asset-categories.constants';

export function useAssetCategoryHelper(): {
    getAssetCategoryManager: (category: AssetCategory) => DataObjectsManager<IDataObject>;
    getAssetCategoryModule: (category: AssetCategory) => string;
    getAssetCategoryDefaultProperties: (category: AssetCategory) => string;
} {
    const getAssetCategoryManager = (category: AssetCategory): DataObjectsManager<IDataObject> => {
        return assetCategoryMap.get(category)?.assetManager;
    };

    const getAssetCategoryModule = (category: AssetCategory): string => {
        return assetCategoryMap.get(category)?.assetModule;
    };

    const getAssetCategoryDefaultProperties = (category: AssetCategory): string => {
        return assetCategoryMap.get(category)?.assetProperties;
    };

    return { getAssetCategoryManager, getAssetCategoryModule, getAssetCategoryDefaultProperties };
}
